import { render, staticRenderFns } from "./SendEmailNotification.vue?vue&type=template&id=6bf63cc4"
import script from "./SendEmailNotification.vue?vue&type=script&lang=js"
export * from "./SendEmailNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports